import { DialogContent as MuiDialogContent, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DialogContent = styled(MuiDialogContent)({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "10px",
  overflowY: "visible",

  ".MuiAutocomplete-root, & > .MuiFormControl-root": {
    width: "45%",
  },
});

export const SkillsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
});

export const SkillsBlock = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",
  marginBottom: "5px",

  "& > .skillName": {
    fontWeight: "600",
    width: "110px",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  "& > .otherSkillName": {
    width: "110px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "GrayText",
  },
});

export const SkillsInfoBlock = styled(Grid)({
  display: "flex",
  flexDirection: "row",

  "& > .skillLevel": {
    whiteSpace: "nowrap",
    maxWidth: "75px",
  },

  "& > .yearsOfExperience": {
    width: "40px",
  },
});

export const NoSkills = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
}));
